import React from 'react';

/**
 * 选点上报弹窗组件
 * 当收到 pick_point_submitted WebSocket 事件时显示
 */
export default function PickPointSubmittedModal({
  visible,
  point,
  onFlyTo,
  onConfirm,
  onClose,
  confirming
}) {
  if (!visible || !point) return null;

  const lat = point.auto_lat || point.used_lat;
  const lng = point.auto_lng || point.used_lng;
  const accuracy = point.auto_accuracy || point.used_accuracy;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        animation: 'fadeIn 0.2s ease-in-out'
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          padding: '24px 28px',
          maxWidth: 480,
          width: '90%',
          boxShadow: '0 12px 48px rgba(0, 0, 0, 0.25)',
          animation: 'slideDown 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <span
            style={{
              fontSize: 32,
              lineHeight: 1
            }}
          >
            📍
          </span>
          <h3
            style={{
              margin: 0,
              fontSize: 20,
              fontWeight: 700,
              color: '#1f2937',
              flex: 1
            }}
          >
            收到新位置上报
          </h3>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              fontSize: 24,
              color: '#9ca3af',
              cursor: 'pointer',
              padding: 0,
              lineHeight: 1,
              transition: 'color 0.2s'
            }}
            onMouseEnter={(e) => (e.target.style.color = '#374151')}
            onMouseLeave={(e) => (e.target.style.color = '#9ca3af')}
          >
            ×
          </button>
        </div>

        <div
          style={{
            background: '#f9fafb',
            borderRadius: 8,
            padding: 16,
            marginBottom: 20,
            fontSize: 14,
            lineHeight: 1.6
          }}
        >
          {point.note && (
            <div style={{ marginBottom: 12 }}>
              <span style={{ color: '#6b7280', fontWeight: 600 }}>备注：</span>
              <span style={{ color: '#1f2937', marginLeft: 8 }}>{point.note}</span>
            </div>
          )}
          {point.created_by_name && (
            <div style={{ marginBottom: 12 }}>
              <span style={{ color: '#6b7280', fontWeight: 600 }}>创建人：</span>
              <span style={{ color: '#1f2937', marginLeft: 8 }}>{point.created_by_name}</span>
            </div>
          )}
          {lat && lng && (
            <div style={{ marginBottom: 12 }}>
              <span style={{ color: '#6b7280', fontWeight: 600 }}>坐标：</span>
              <span style={{ color: '#1f2937', marginLeft: 8, fontFamily: 'monospace' }}>
                {lat.toFixed(6)}, {lng.toFixed(6)}
              </span>
            </div>
          )}
          {accuracy && (
            <div>
              <span style={{ color: '#6b7280', fontWeight: 600 }}>精度：</span>
              <span style={{ color: '#1f2937', marginLeft: 8 }}>±{Math.round(accuracy)} 米</span>
            </div>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            gap: 12,
            justifyContent: 'flex-end'
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              borderRadius: 6,
              border: '1px solid #d1d5db',
              background: '#fff',
              color: '#374151',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              minWidth: 80
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#f9fafb';
              e.target.style.borderColor = '#9ca3af';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#fff';
              e.target.style.borderColor = '#d1d5db';
            }}
          >
            关闭
          </button>
          <button
            onClick={() => {
              onFlyTo(point);
            }}
            style={{
              padding: '10px 20px',
              borderRadius: 6,
              border: '1px solid #3b82f6',
              background: '#fff',
              color: '#3b82f6',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
              transition: 'all 0.2s',
              minWidth: 120
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#eff6ff';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#fff';
            }}
          >
            飞行到位置
          </button>
          <button
            onClick={() => {
              onConfirm(point);
            }}
            disabled={confirming}
            style={{
              padding: '10px 20px',
              borderRadius: 6,
              border: 'none',
              background: confirming ? '#9ca3af' : '#16a34a',
              color: '#fff',
              fontSize: 14,
              fontWeight: 600,
              cursor: confirming ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              minWidth: 120
            }}
            onMouseEnter={(e) => {
              if (!confirming) e.target.style.background = '#15803d';
            }}
            onMouseLeave={(e) => {
              if (!confirming) e.target.style.background = '#16a34a';
            }}
          >
            {confirming ? '确认中...' : '确认上报'}
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
